<template>
    <!--nav-->
    <nav class="navbar navbar-default no-margin app-sidebar-nav">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header fixed-brand" style="background: #FFFFFF;">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" id="menu-toggle" v-on:click.prevent="menuTtoggleMobile(sidebarType)">
                <span class="" aria-hidden="true"></span>
            </button>
            <router-link v-bind:to="{ path:'/'}" class="navbar-brand"><img src="/static/images/vvg-home-logo.png" alt="HR Portal"></router-link>
        </div>
        <!-- navbar-header-->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul class="nav navbar-nav">
                <li class="active">
                    <button class="navbar-toggle collapse in" data-toggle="collapse" id="menu-toggle-2" v-on:click.prevent="menuTtoggleDesktop(sidebarType)"> 
                        <img src="/static/images/menubar.png" alt="Menu" class="menubar">
                    </button>
                </li>
            </ul>
            <button type="button" title='Download Directory' v-on:click.prevent="download()" class="downloadDirectory btn btn-primary waves-effect pull-left"><i class="fa fa-download" aria-hidden="true"></i></button>
        </div>
        <!--notification-->
        <!--<div class="notification">
            <a href="#">
                <img src="/static/images/notification-bell.png" alt="Notification">
            </a>
        </div>-->
        <!--notification-->
        <!--userinfo-->
        <div id="wrap">
            <form action="" autocomplete="on" v-on:submit.prevent="universalSearchAPI()">
                <input v-model="universalSearchText" id="search" name="search" type="text" placeholder="Search..." required=""><input id="search_submit" value="Rechercher" type="submit">
            </form>
        </div>
        <div class="user-info">
            <div class="user-info-container">
                <div class="dropdown">
                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <div class="dropdown-user">
                            <!--<div class="username-letter">AG</div>-->
                            <div class="image"><img :src="profile_image" alt="User" width="48" height="48"></div>
                            <div class="dropdown-user-right">
                                <div class="username">{{firstName}} {{lastName}}</div>
                                <br/>
                                <div class="usermailid">{{email}}</div>
                            </div>
                        </div>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="#" v-on:click.prevent="logout()">Logout</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- bs-example-navbar-collapse-1 -->
    </nav>
</template>

<script>
    import Vue from "vue";
    import EventBus from '../../event-bus';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    var self;
    export default {
        mixins: [SessioMixin],
        name: 'App',
        data() {
            return {
                userPermissions: [],
                roleId: 0,
                roleName: 0,
                system_year: '',
                isShowLoggedinfields: true,
                showEditProfile: true,
                isLoggedIn: false,
                firstName: "",
                lastName: "",
                email: "",
                profile_image: "",
                loggedinUserId: "",
                universalSearchText: "",
                sidebarType: ""
            }
        },
        components: {
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            self.getPermissions();
        },
        mounted: function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[1] == "directory") {
                self.showEditProfile = false;
            }
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"], localStorage.getItem("profile_image"));
            }
        },
        methods: {
            universalSearchAPI: function () {
                self.$router.push("/directory/extensionslist/" + self.universalSearchText);
            },
            download: function () {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    /*params: {
                        department_id: self.department_id,
                        site_id: self.location,
                    }*/
                };
                self.showLoader();
                HTTP.get('contactdownload', config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                location.href = response.data.content.web;
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                            self.hideLoader();
                        })
            },
        },
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
            if ((self.roleId != 1 && self.roleId != 0) && self.userPermissions.indexOf('add_contact_extension') <= -1) {
                /*self.$router.push("/");*/
            }
        }
    });
    EventBus.$on('logged-in', function (isLogin, fname, lname, email, profile_image) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.firstName = fname;
            self.lastName = lname;
            self.email = email;
            self.profile_image = (profile_image != '') ? profile_image : '/static/images/default.jpg';
        }
    });

    EventBus.$on('searchText', function (data) {
        self.universalSearchText = data;
    });
    EventBus.$on('sidebarType', function (data) {
        if (typeof (self) != "undefined") {
            self.sidebarType = data;
        }
    });


</script>



// WEBPACK FOOTER //
// src/components/backend/partials/ExtensionHeader.vue